/**
 * Possible names for the telemetry element property in TraceContext
 */
export enum ElementName {
  AboutPageAnalyticsCard = 'about-page-analytics-card',
  AboutPageBuyCryptoCard = 'about-page-buy-crypto-card',
  AboutPageDevDocsCard = 'about-page-dev-docs-card',
  AboutPageEarnCard = 'about-page-earn-card',
  AboutPageNftsCard = 'about-page-nfts-card',
  AboutPageSwapCard = 'about-page-swap-card',
  AboutPageSwapElement = 'about-page-swap-element',
  AcceptNewRate = 'accept-new-rate',
  AccountCard = 'account-card',
  AddCloudBackup = 'add-cloud-backup',
  AddHook = 'add-hook',
  AddManualBackup = 'add-manual-backup',
  AddPasskey = 'add-passkey',
  AddPasskeyCrossPlatform = 'add-passkey-cross-platform',
  AddPasskeyPlatform = 'add-passkey-platform',
  AddViewOnlyWallet = 'add-view-only-wallet',
  AppCrashScreen = 'app-crash-screen',
  AutorouterVisualizationRow = 'expandable-autorouter-visualization-row',
  BackButton = 'back-button',
  BlogLink = 'blog-link',
  BridgedAssetTDPSection = 'bridged-asset-tdp-section',
  BridgeNativeTokenButton = 'bridge-native-token-button',
  Buy = 'buy',
  BuyNativeTokenButton = 'buy-native-token-button',
  Cancel = 'cancel',
  CareersLink = 'careers-link',
  ChainArbitrum = 'chain-arbitrum',
  ChainAvalanche = 'chain-avalanche',
  ChainBase = 'chain-base',
  ChainBNB = 'chain-bnb',
  ChainBlast = 'chain-blast',
  ChainCelo = 'chain-celo',
  ChainEthereum = 'chain-ethereum',
  ChainMonadTestnet = 'chain-monad-testnet',
  ChainOptimism = 'chain-optimism',
  ChainPolygon = 'chain-polygon',
  ChainSepolia = 'chain-sepolia',
  ChainSolana = 'chain-solana',
  ChainSoneium = 'chain-soneium',
  ChainUnichain = 'chain-unichain',
  ChainUnichainSepolia = 'chain-unichain-sepolia',
  ChainWorldChain = 'chain-world-chain',
  ChainZkSync = 'chain-zksync',
  ChainZora = 'chain-zora',
  ChooseInputToken = 'choose-input-token',
  ChooseOutputToken = 'choose-output-token',
  ClearPending = 'clear-pending',
  CloseButton = 'close-button',
  CommonBasesCurrencyButton = 'common-bases-currency-button',
  Confirm = 'confirm',
  ConfirmSwapButton = 'confirm-swap-or-send',
  ConnectExistingWallet = 'connect-existing-wallet',
  ConnectWalletButton = 'connect-wallet-button',
  Continue = 'continue',
  ContinueButton = 'continue-button',
  Copy = 'copy',
  CopyAddress = 'copy-address',
  CreateAccount = 'create-account',
  CreateAWallet = 'create-a-wallet',
  CreatePasskey = 'create-passkey',
  DeletePasskey = 'delete-passkey',
  DeletePasskeyAcknowledge = 'delete-passkey-acknowledge',
  Disconnect = 'disconnect',
  DisconnectWalletButton = 'disconnect-wallet-button',
  DocsLink = 'docs-link',
  DownloadApp = 'download-app-modal',
  DownloadButton = 'download-button',
  EmptyStateBuy = 'empty-state-buy',
  EmptyStateCEXTransfer = 'empty-state-cex-transfer',
  EmptyStateImport = 'empty-state-get-import',
  EmptyStateReceive = 'empty-state-receive',
  Enable = 'enable',
  EtherscanView = 'etherscan-view',
  ExploreBanner = 'explore-banner',
  ExplorePoolsTab = 'explore-pools-tab',
  ExploreSearchInput = 'explore_search_input',
  ExploreTokensTab = 'explore-tokens-tab',
  ExploreTransactionsTab = 'explore-transactions-tab',
  ExtensionDownloadButton = 'extension-download-button',
  ExtensionDownloadConnector = 'extension-download-connector',
  ExtensionPopupOpenButton = 'extension-popup-open-button',
  FiatOnRampBuyButton = 'fiat-on-ramp-buy-button',
  FiatOnRampCountryPicker = 'fiat-on-ramp-country-picker',
  FiatOnRampLearnMoreLink = 'fiat-on-ramp-learn-more-link',
  FiatOnRampTokenSelector = 'fiat-on-ramp-token-selector',
  FiatOnRampWidgetButton = 'fiat-on-ramp-widget-button',
  ForEmptyStateBuy = 'for-empty-state-buy',
  ForEmptyStateCEXTransfer = 'for-empty-state-cex-transfer',
  ForEmptyStateReceive = 'for-empty-state-receive',
  GetHelp = 'get-help',
  GetTheApp = 'get-the-app',
  ImportAccount = 'import-account',
  ImportTokenButton = 'import-token-button',
  InlineWarningCardCheckbox = 'inline-warning-card-checkbox',
  LandingPageSwapElement = 'landing-page-swap-element',
  LearnMoreLink = 'learn-more-link',
  LegacyLandingPageLink = 'legacy-landing-page-link',
  LimitOrderButton = 'limit-order-button',
  LiquidityDefaultPriceStrategy = 'liquidity-default-price-strategy',
  MaxTokenAmountButton = 'max-token-amount-button',
  MaybeLaterButton = 'maybe-later-button',
  MiniPortfolioActivityRow = 'mini-portfolio-activity-row',
  MiniPortfolioActivityTab = 'mini-portfolio-activity-tab',
  MiniPortfolioPoolsRow = 'mini-portfolio-pools-row',
  MiniPortfolioPoolsTab = 'mini-portfolio-pools-tab',
  MiniPortfolioNftItem = 'mini-portfolio-nft-item',
  MiniPortfolioNftTab = 'mini-portfolio-nft-tab',
  MiniPortfolioTokenRow = 'mini-portfolio-token-row',
  MiniPortfolioTokensTab = 'mini-portfolio-tokens-tab',
  MoonpayExplorerView = 'moonpay-explorer-view',
  NavbarSearchInput = 'navbar-search-input',
  NetworkButton = 'network-button',
  Next = 'next',
  NftActivityTab = 'nft-activity-tab',
  NftBuyBagPayButton = 'nft-buy-bag-pay-button',
  NftFilterButton = 'nft-filter-button',
  NftFilterOption = 'nft-filter-option',
  NftItem = 'nft-item',
  NftTrendingRow = 'nft-trending-row',
  OK = 'ok',
  OnboardingImportBackup = 'onboarding-import-backup',
  OnboardingImportSeedPhrase = 'onboarding-import-seed-phrase',
  OnboardingImportViewPrivateKeys = 'onboarding-import-view-private-keys',
  OnboardingIntroCardEnablePushNotifications = 'onboarding-intro-card-enable-push-notifications',
  OnboardingIntroCardFundWallet = 'onboarding-intro-card-fund-wallet',
  OnboardingPasskey = 'onboarding-passkey',
  OnDeviceRecoveryImportOther = 'on-device-recovery-import-other',
  OnDeviceRecoveryModalCancel = 'on-device-recovery-modal-cancel',
  OnDeviceRecoveryModalConfirm = 'on-device-recovery-modal-confirm',
  OnDeviceRecoveryWallet = 'on-device-recovery-wallet',
  OpenCameraRoll = 'open-camera-roll',
  OpenNftsList = 'open-nfts-list',
  PoolsTableRow = 'pools-table-row',
  PoolOutOfSyncError = 'pool-out-of-sync-error',
  PreselectAsset = 'preselect-asset',
  PresetPercentage = 'preset-percentage',
  PriceUpdateAcceptButton = 'price-update-accept-button',
  QRCodeModalToggle = 'qr-code-modal-toggle',
  Receive = 'receive',
  RecoveryHelpButton = 'recovery-help-button',
  Remove = 'remove',
  RestoreFromCloud = 'restore-from-cloud',
  RestoreWalletModal = 'restore-wallet-modal',
  SearchTab = 'search-tab',
  Send = 'send',
  SendButton = 'send-button',
  SendFiatToggle = 'send-fiat-toggle',
  SendMaxButton = 'send-max-button',
  SendReview = 'send-review',
  SendReviewButton = 'send-review-button',
  SetPercentageInput = 'set-percentage-input',
  SetPercentageOutput = 'set-percentage-output',
  SettingsCurrencyOption = 'settings-currency-option',
  SettingsLanguageOption = 'settings-language-option',
  SignIn = 'sign-in',
  Skip = 'skip',
  SmartWalletDisclaimer = 'smart-wallet-disclaimer',
  SmartWalletEnabled = 'smart-wallet-enabled',
  SmartWalletNotNow = 'smart-wallet-not-now',
  SupportLink = 'support-link',
  Swap = 'swap',
  SwapButton = 'swap-button',
  SwapDetailsDropdown = 'swap-details-dropdown',
  SwapFormHeader = 'swap-form-header',
  SwapReview = 'swap-review',
  SwapRoutingPreferenceDefault = 'swap-routing-preference-default',
  SwapRoutingPreferenceUniswapX = 'swap-routing-preference-UniswapX',
  SwapRoutingPreferenceV2 = 'swap-routing-preference-v2',
  SwapRoutingPreferenceV3 = 'swap-routing-preference-v3',
  SwapRoutingPreferenceV4 = 'swap-routing-preference-v4',
  SwapRoutingPreferenceV4Hooks = 'swap-routing-preference-v4-hooks',
  SwapTokensReverseArrowButton = 'swap-tokens-reverse-arrow-button',
  SwitchCurrenciesButton = 'switch-currencies-button',
  TaxServiceBannerCtaButton = 'tax-service-banner-learn-more-button',
  TaxServiceCointrackerButton = 'tax-service-cointracker-link-button',
  TaxServiceTokentaxButton = 'tax-service-tokentax-link-button',
  TDPActionMenuButton = 'tdp-action-menu-button',
  TimeFrame1D = 'time-frame-1D',
  TimeFrame1H = 'time-frame-1H',
  TimeFrame1M = 'time-frame-1M',
  TimeFrame1W = 'time-frame-1W',
  TimeFrame1Y = 'time-frame-1Y',
  TimeFrameAll = 'time-frame-All',
  TokenAddress = 'token-address',
  TokenInputSelector = 'token-input-selector',
  TokenItem = 'token-item',
  TokenLinkEtherscan = 'token-link-etherscan',
  TokenLinkTwitter = 'token-link-twitter',
  TokenLinkWebsite = 'token-link-website',
  TokenOutputSelector = 'token-output-selector',
  TokenSelectorRow = 'token-selector-row',
  TokenWarningCard = 'token-warning-card',
  TokensTableRow = 'tokens-table-row',
  TwitterLink = 'twitter-link',
  UniswapWalletBannerDownloadButton = 'uniswap-wallet-banner-download-button',
  UniswapWalletConnector = 'uniswap-wallet-connector',
  UniswapWalletLandingPageDownloadButton = 'uniswap-wallet-landing-page-download-button',
  UniswapWalletModalDownloadButton = 'uniswap-wallet-modal-download-button',
  UniswapWalletNavbarMenuDownloadButton = 'uniswap-wallet-navbar-menu-download-button',
  Unwrap = 'unwrap',
  ViewNativePrivateKeysOnCopied = 'view-native-private-keys-on-copied',
  WalletCard = 'wallet-card',
  WalletConnectScan = 'wallet-connect-scan',
  WalletQRCode = 'wallet-qr-code',
  WalletTypeOption = 'wallet-type-option',
  Wrap = 'wrap',
  // alphabetize additional values.
}
